import React, { useEffect, useState, useRef } from "react";

import "./BlockDeals.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";
import useNiftyWebsocket from "service/websocket/NiftyWebsocketApi";


export default function BlockDeals() {

    // WebSocket connection
    const { blockDealsData } = useStockApiWebsocket(environment.stockApiDayRangeDataWSUrl);
    const { nseWebsiteOIResponseData } = useNiftyWebsocket(environment.niftyWebsocketUrl);
    const [blockDealsDataList, setBlockDealsDataList] = useState([]);
    const [activeTab, setActiveTab] = useState("BLOCK_DEALS");
    const [nseWebsiteOIResposneDataList, setNseWebsiteOIResposneDataList] = useState(null);
    /* ============================================== */
    const oiRecordTimeMap = useRef(new Map());
    useEffect(() => {
        if (Array.isArray(blockDealsData) && blockDealsData.length > 0) {
            setBlockDealsDataList(blockDealsData);
            console.log(blockDealsData);
        }
        setNseWebsiteOIResposneDataList(buildNseWebsiteOIResponseOIDataMap(nseWebsiteOIResponseData));
        console.log('nseWebsiteOIResposneDataList => ', nseWebsiteOIResposneDataList);
    }, [blockDealsData, nseWebsiteOIResponseData]);

    const buildNseWebsiteOIResponseOIDataMap = (response) => {

        const processList = (list = []) => {
            return list.map((record) => {

                const key = `${record.symbol}_${record.instrument}_${record.expiryDate}_${record.optionType}`;

                // ✅ Only set time for new record
                if (!oiRecordTimeMap.current.has(key)) {
                    oiRecordTimeMap.current.set(key, new Date().toLocaleTimeString());
                }

                return {
                    ...record,
                    time: oiRecordTimeMap.current.get(key)
                };
            });
        };

        const getOIData = (key) => {
            const responseData = response?.data || [];

            for (let item of responseData) {
                const source = item?.categories || item;
                const value = source?.[key];
                if (value) {
                    return processList(value); // ✅ Apply timestamp here
                }
            }
            return [];
        };

        return {
            "Rise-in-OI-Rise": getOIData("Rise-in-OI-Rise"),
            "Rise-in-OI-Slide": getOIData("Rise-in-OI-Slide"),
            "Slide-in-OI-Rise": getOIData("Slide-in-OI-Rise"),
            "Slide-in-OI-Slide": getOIData("Slide-in-OI-Slide")
        };
    };
    // Header Data
    const headerSource = blockDealsDataList?.[0] ?? {};
    const headerData = [
        {
            label1: "Date",
            value1: headerSource?.localDate ?? "--",
            label2: "Time",
            value2: headerSource?.localTime ?? "--",
        },
    ];

    const formatValue = (value) => {
        if (value == null || isNaN(value)) return "--";

        const num = Number(value);
        const absNum = Math.abs(num);
        const sign = num < 0 ? "-" : "";


        // 🔥 Whole number (no decimal)
        if (Number.isInteger(num)) {
            return `${sign}${absNum.toLocaleString("en-IN")}`;
        }

        // 🔥 Default (Indian format with 2 decimal)
        return `${sign}${absNum.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    const getValueClass = (value) => (value < 0 ? "span-color-red" : "span-color-green");
    return (
        <div className="block-deals-page">

            {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">

                    {/* LEFT SIDE - LOGO */}
                    <div className="left-nav">
                        <div className="logo-container">
                            <img
                                src="/assets/images/noptionwave-logo-1.png"
                                className="header-logo"
                                alt="noptionwave logo"
                            />
                        </div>
                    </div>

                    {/* RIGHT SIDE - HEADER DATA */}
                    <div className="right-nav">
                        {headerData.map((item, idx) => (
                            <div className="header-item" key={idx}>
                                <span className="header-line">
                                    {item.label1} : {item.value1}
                                </span>
                                <span className="header-line">
                                    {item.label2} : {item.value2}
                                </span>
                            </div>
                        ))}
                    </div>

                </nav>
            </header>

            {/* ===== TABS ===== */}
            <div className="tab-container">
                <div className="tab">

                    <button className={`tablinks sub-header-font ${activeTab === "BLOCK_DEALS" ? "active" : ""}`}
                        onClick={() => setActiveTab("BLOCK_DEALS")}  >
                        BLOCK DEALS
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "BUYING" ? "active" : ""}`}
                        onClick={() => setActiveTab("BUYING")} >
                        BUYING
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "SELLING" ? "active" : ""}`}
                        onClick={() => setActiveTab("SELLING")} >
                        SELLING
                    </button>
                    <button className={`tablinks sub-header-font ${activeTab === "WEAK_SELLING" ? "active" : ""}`}
                        onClick={() => setActiveTab("WEAK_SELLING")} >
                        WEAK SELLING
                    </button>
                    <button className={`tablinks sub-header-font ${activeTab === "WEAK_BUYING" ? "active" : ""}`}
                        onClick={() => setActiveTab("WEAK_BUYING")} >
                        WEAK BUYING
                    </button>
                </div>
            </div>

            {/* ================= GRID ================= */}

            {/* ===== BLOCK DEALS ===== */}
            {activeTab === "BLOCK_DEALS" && (
                <div className="table-container">

                    <table className="responsive-table text-center sticky-header">
                        <thead>
                            <tr>
                                <th>DEAL DATE & TIME</th>
                                <th>SYMBOL</th>
                                <th>TRADED PRICE</th>
                                <th>DEAL VALUE & QUANTITY</th>
                                <th>SECTOR</th>
                                <th>VOLUME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blockDealsDataList?.length > 0 ? (
                                blockDealsDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="deal-cell">

                                            <div className="deal-row">
                                                <span>{row.deal_date ?? "--"}</span>
                                                <span className="span-color-price">
                                                    {row.deal_time
                                                        ? `${row.deal_time.slice(0, 2)}:${row.deal_time.slice(2)}`
                                                        : "--"}
                                                </span>
                                            </div>
                                        </td>
                                        <td> <span className="span-color-price">{row.sc_nseid ?? "--"}</span></td>
                                        <td><span className="span-color-price">Price: {formatValue(row.tradedPrice) ?? "--"}</span></td>
                                        <td className="deal-cell">
                                            <div className="deal-row">

                                                <span>Rs.</span>
                                                <span className="span-color">{row.dealValue ?? "--"} </span>

                                                <span>Crores</span>
                                                <span>NSE Block Trade For</span>
                                                <span className="span-color">{formatValue(row.quantity) ?? "--"}</span>
                                                <span>Shares</span>


                                            </div>
                                        </td>
                                        <td>{row.stock_sector ?? "--"}</td>
                                        <td><span>{formatValue(row.volume) ?? "--"}</span></td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="15">Waiting for live data...</td>
                                </tr>
                            )}
                        </tbody>

                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== BUYING ===== */}
            {activeTab === "BUYING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th> */}
                                {/* <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Rise-in-OI-Rise"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td> */}
                                        {/* <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== SELLING ===== */}
            {activeTab === "SELLING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th>
                                <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Rise-in-OI-Slide"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td>
                                        <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== WEAK SELLING ===== */}
            {activeTab === "WEAK_SELLING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th>
                                <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Slide-in-OI-Slide"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td>
                                        <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== WEAK BUYING ===== */}
            {activeTab === "WEAK_BUYING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th>
                                <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Slide-in-OI-Rise"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td>
                                        <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

        </div>
    );
}